module.exports = __webpack_public_path__ + "files/27926e7219e78a7b9d285a52ef59e7c8.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-6.png
// module id = 503
// module chunks = 76